import config from '@/config';
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useUpdateAssignedUser = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (values) {
        return api.base
            .put("".concat(config.appUrls.tasks, "/api/plannedTasks/UpdateAssignedUser"), {
            taskId: values.taskId,
            userId: values.userId,
            taskLevel: values.taskLevel,
        })
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries([TaskQueryKey.PlannedTasks]);
        },
        onError: function (e) {
            handleHttpError(intl)(e);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        updateAssignedUser: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
